module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hxizP"))).then(() => parcelRequire('hEqeo'));